// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type SelectedUomState = {
    selectedUomByProductId: {
        [productId: string]: string;
    };
    multiplesOfByProductId: {
        [productId: string]: number;
    };
    quickOrderUomIds: {
        [id: string]: number;
    };
};

const initialSelectedUomState: SelectedUomState = {
    selectedUomByProductId: {},
    multiplesOfByProductId: {},
    quickOrderUomIds: {},
};

const xSelectedUom = createTypedReducerWithImmer(initialSelectedUomState, {
    "xUpdateSelectedUom/setSelectedUom": (
        draft: Draft<SelectedUomState>,
        action: { productId: string; selectedUom: string; multiplesOf: number; quickOrder?: boolean },
    ) => {
        draft.selectedUomByProductId[action.productId] = action.selectedUom;
        draft.multiplesOfByProductId[action.productId] = action.multiplesOf;
        if (action.quickOrder) {
            draft.quickOrderUomIds[action.productId + action.selectedUom] = action.multiplesOf;
        }
    },
    "xUpdateSelectedUom/resetSelectedUom": (draft: Draft<SelectedUomState>, action: { productId: string }) => {
        delete draft.selectedUomByProductId[action.productId];
        delete draft.multiplesOfByProductId[action.productId];
    },
    "xUpdateSelectedUom/resetQuickOrder": (draft: Draft<SelectedUomState>) => {
        draft.selectedUomByProductId = {};
        draft.multiplesOfByProductId = {};
        draft.quickOrderUomIds = {};
    },
});

(reducers as any).xSelectedUom = xSelectedUom;

export type xSelectedUomState = {
    xSelectedUom: SelectedUomState;
} & ApplicationState;

type xSelectedUomReducers = {
    selectedUom: typeof xSelectedUom;
};

export type xSelectedUomActions = Parameters<xSelectedUomReducers[keyof xSelectedUomReducers]>[1] | AnyAction;
